/**
 * Configurações do Embedded Signup do WhatsApp.
 *
 * São duas configurações distintas no Meta App Dashboard:
 *
 * - PADRÃO: onboarding de um número novo/dedicado ao Cloud API. O backend
 *   registra o número (`/{phone_number_id}/register`) com um PIN.
 * - COEXISTÊNCIA: onboarding de um número que o cliente já usa no app WhatsApp
 *   Business. O número já vem registrado pela verificação do app, e a Meta passa
 *   a enviar os webhooks `smb_message_echoes`, `smb_app_state_sync` e `history`.
 *
 * Segundo a doc da Meta, assinar os webhooks de coexistência já faz a opção
 * aparecer no Embedded Signup padrão — um config_id separado provavelmente é
 * desnecessário. O `VITE_WHATSAPP_COEX_CONFIG_ID` fica como escape hatch para
 * instalações onde a opção só aparece numa configuração própria; vazio (o
 * caso normal) simplesmente esconde o botão dedicado, sem afetar o fluxo
 * padrão — que hoje conclui em coexistência sozinho, pelo evento.
 */
const FB_CONFIG_ID_PADRAO = '690426000585914';

const FB_CONFIG_ID_COEXISTENCIA: string | undefined =
    import.meta.env.VITE_WHATSAPP_COEX_CONFIG_ID || undefined;

export const coexistenciaDisponivel = (): boolean => !!FB_CONFIG_ID_COEXISTENCIA;

/** Modo de signup carregado na querystring do popup (`?mode=coex`). */
export type SignupMode = 'padrao' | 'coex';

export const parseSignupMode = (value: string | null): SignupMode =>
    value === 'coex' ? 'coex' : 'padrao';

export const configIdParaModo = (modo: SignupMode): string | undefined =>
    modo === 'coex' ? FB_CONFIG_ID_COEXISTENCIA : FB_CONFIG_ID_PADRAO;
